export function createDerivedState(config) {
  return {
    visible: true,
    disabled: config.isNonEditable === true,
    required: config.isRequired === true,
    options: Array.isArray(config.options) ? [...config.options] : [],
    forcedValue: undefined,
  };
}
